import { render, staticRenderFns } from "./GoContact.vue?vue&type=template&id=202f83b7"
import script from "./GoContact.vue?vue&type=script&lang=js"
export * from "./GoContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports